/**
 * 检测信息数据列表
 * http://mockjs.com/
 */
export default {
  auctionCheckModeList: {
    'head': [
      {
        'id': 1,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          },
          {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          },
          {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '破损裂痕',
            'selected': false
          }, {
            'key': '10',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '前保险杠',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 2,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '水雾',
            'selected': false
          }, {
            'key': '4',
            'value': '破损裂痕',
            'selected': false
          }, {
            'key': '5',
            'value': '更换过',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左前大灯',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 3,
        'model': '',
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '水雾',
            'selected': false
          }, {
            'key': '4',
            'value': '破损裂痕',
            'selected': false
          }, {
            'key': '5',
            'value': '更换过',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右前大灯',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 4,
        'model': '',
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '修复痕迹',
            'selected': false
          }, {
            'key': '3',
            'value': '变形',
            'selected': false
          }, {
            'key': '4',
            'value': '淤泥痕迹',
            'selected': false
          }, {
            'key': '5',
            'value': '更换过',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '前横梁',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 5,
        'model': '',
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '修复痕迹',
            'selected': false
          }, {
            'key': '3',
            'value': '变形',
            'selected': false
          }, {
            'key': '4',
            'value': '破损',
            'selected': false
          }, {
            'key': '5',
            'value': '更换过',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }],
        'note': '水箱支架',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 6,
        'model': '',
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '纵梁更换',
            'selected': false
          }, {
            'key': '3',
            'value': '纵梁变形',
            'selected': false
          }, {
            'key': '4',
            'value': '纵梁修复痕迹',
            'selected': false
          }, {
            'key': '5',
            'value': '梁头更换',
            'selected': false
          }, {
            'key': '6',
            'value': '梁头变形',
            'selected': false
          }, {
            'key': '7',
            'value': '梁头修复痕迹',
            'selected': false
          }, {
            'key': '8',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左前纵梁',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 7,
        'model': '',
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '纵梁更换',
            'selected': false
          }, {
            'key': '3',
            'value': '纵梁变形',
            'selected': false
          }, {
            'key': '4',
            'value': '纵梁修复痕迹',
            'selected': false
          }, {
            'key': '5',
            'value': '梁头更换',
            'selected': false
          }, {
            'key': '6',
            'value': '梁头变形',
            'selected': false
          }, {
            'key': '7',
            'value': '梁头修复痕迹',
            'selected': false
          }, {
            'key': '8',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右前纵梁',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 8,
        'model': '',
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '修复',
            'selected': false
          }, {
            'key': '3',
            'value': '变形',
            'selected': false
          }, {
            'key': '4',
            'value': '更换过',
            'selected': false
          }, {
            'key': '5',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左前避震器座',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 9,
        'model': '',
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '修复',
            'selected': false
          }, {
            'key': '3',
            'value': '变形',
            'selected': false
          }, {
            'key': '4',
            'value': '更换过',
            'selected': false
          }, {
            'key': '5',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右前避震器座',
        'defaultTitle': ['正常'],
        'title': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 10,
        'model': '',
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '变形',
            'selected': false
          }, {
            'key': '3',
            'value': '钣金修复',
            'selected': false
          }, {
            'key': '4',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '防火墙',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 11,
        'model': '',
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          }, {
            'key': '4',
            'value': '裂痕',
            'selected': false
          },
          {
            'key': '5',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '前挡风玻璃',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 12,
        'model': '',
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '钣金修复',
            'selected': false
          }, {
            'key': '3',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '4',
            'value': '变形',
            'selected': false
          }, {
            'key': '5',
            'value': '更换过',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '车顶',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 13,
        'model': '',
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          }, {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '锈蚀',
            'selected': false
          }, {
            'key': '10',
            'value': '钣金修复',
            'selected': false
          }, {
            'key': '11',
            'value': '更换过',
            'selected': false
          }, {
            'key': '12',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '引擎盖',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 14,
        'model': '',
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          }, {
            'key': '2',
            'value': '锈蚀',
            'selected': false
          }, {
            'key': '3',
            'value': '磨痕',
            'selected': false
          }, {
            'key': '4',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '车底板',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      }
    ],
    'left': [
      {
        'id': 15,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          }, {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '锈蚀',
            'selected': false
          }, {
            'key': '10',
            'value': '钣金修复',
            'selected': false
          }, {
            'key': '11',
            'value': '更换过',
            'selected': false
          }, {
            'key': '12',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左前叶子板',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 16,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '严重刮伤',
            'selected': false
          },
          {
            'key': '4',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '5',
            'value': '改装',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左前轮毂',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 17,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '严重刮伤',
            'selected': false
          },
          {
            'key': '4',
            'value': '胎纹过浅',
            'selected': false
          }, {
            'key': '5',
            'value': '改装',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左前轮胎',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 18,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕（见底漆）',
            'selected': false
          },
          {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '破损裂痕',
            'selected': false
          }, {
            'key': '10',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左后视镜',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 19,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕（见底漆）',
            'selected': false
          },
          {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '锈蚀',
            'selected': false
          }, {
            'key': '10',
            'value': '钣金修复',
            'selected': false
          },
          {
            'key': '11',
            'value': '更换过',
            'selected': false
          }, {
            'key': '12',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左前门',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 20,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '3',
            'value': '钣金修复',
            'selected': false
          },
          {
            'key': '4',
            'value': '焊接痕迹',
            'selected': false
          }, {
            'key': '5',
            'value': '切割痕迹',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左A柱',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 21,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          },
          {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '锈蚀',
            'selected': false
          }, {
            'key': '10',
            'value': '钣金修复',
            'selected': false
          }, {
            'key': '11',
            'value': '更换过',
            'selected': false
          }, {
            'key': '12',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左后门',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 22,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '3',
            'value': '钣金修复',
            'selected': false
          },
          {
            'key': '4',
            'value': '焊接痕迹',
            'selected': false
          }, {
            'key': '5',
            'value': '切割痕迹',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左B柱',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 23,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '3',
            'value': '钣金修复',
            'selected': false
          },
          {
            'key': '4',
            'value': '焊接痕迹',
            'selected': false
          }, {
            'key': '5',
            'value': '切割痕迹',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左C柱',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 24,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          },
          {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '锈蚀',
            'selected': false
          }, {
            'key': '10',
            'value': '钣金修复',
            'selected': false
          }, {
            'key': '11',
            'value': '更换过',
            'selected': false
          }, {
            'key': '12',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左后叶子板',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 25,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '严重刮伤',
            'selected': false
          },
          {
            'key': '4',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '5',
            'value': '改装',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左后轮毂',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 26,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '严重刮伤',
            'selected': false
          },
          {
            'key': '4',
            'value': '胎纹过浅',
            'selected': false
          }, {
            'key': '5',
            'value': '改装',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左后轮胎',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 27,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '严重刮伤',
            'selected': false
          },
          {
            'key': '4',
            'value': '变形',
            'selected': false
          }, {
            'key': '5',
            'value': '修复痕迹',
            'selected': false
          }, {
            'key': '6',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '7',
            'value': '更换过',
            'selected': false
          }, {
            'key': '8',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左裙边',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      }
    ],
    'tail': [
      {
        'id': 28,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '水雾',
            'selected': false
          },
          {
            'key': '4',
            'value': '破损裂痕',
            'selected': false
          }, {
            'key': '5',
            'value': '更换过',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '左后大灯',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 29,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '水雾',
            'selected': false
          },
          {
            'key': '4',
            'value': '破损裂痕',
            'selected': false
          }, {
            'key': '5',
            'value': '更换过',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右后大灯',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 30,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          },
          {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '锈蚀',
            'selected': false
          }, {
            'key': '10',
            'value': '钣金修复',
            'selected': false
          }, {
            'key': '11',
            'value': '更换过',
            'selected': false
          }, {
            'key': '12',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '后行李箱盖',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 31,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          },
          {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '破损裂痕',
            'selected': false
          }, {
            'key': '10',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '后保险杠',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 32,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕',
            'selected': false
          },
          {
            'key': '4',
            'value': '裂痕',
            'selected': false
          }, {
            'key': '5',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '后挡风玻璃',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 33,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '严重刮伤',
            'selected': false
          },
          {
            'key': '4',
            'value': '胎纹过浅',
            'selected': false
          }, {
            'key': '5',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '备胎',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 34,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '缺灭火器',
            'selected': false
          }, {
            'key': '3',
            'value': '缺三角警示牌',
            'selected': false
          },
          {
            'key': '4',
            'value': '缺千斤顶',
            'selected': false
          }, {
            'key': '5',
            'value': '缺轮胎扳手',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '随车工具',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 35,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '修复痕迹',
            'selected': false
          }, {
            'key': '3',
            'value': '变形',
            'selected': false
          },
          {
            'key': '4',
            'value': '锈蚀',
            'selected': false
          }, {
            'key': '5',
            'value': '水渍或泥沙',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '备胎室',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      }
    ],
    'right': [
      {
        'id': 36,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          },
          {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '锈蚀',
            'selected': false
          }, {
            'key': '10',
            'value': '钣金修复',
            'selected': false
          }, {
            'key': '11',
            'value': '更换过',
            'selected': false
          }, {
            'key': '12',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右后叶子板',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 37,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '严重刮伤',
            'selected': false
          },
          {
            'key': '4',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '5',
            'value': '改装',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右后轮毂',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 38,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '严重刮伤',
            'selected': false
          },
          {
            'key': '4',
            'value': '胎纹过浅',
            'selected': false
          }, {
            'key': '5',
            'value': '改装',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右后轮胎',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 39,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          },
          {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '锈蚀',
            'selected': false
          }, {
            'key': '10',
            'value': '钣金修复',
            'selected': false
          }, {
            'key': '11',
            'value': '更换过',
            'selected': false
          }, {
            'key': '12',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右后门',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 40,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '3',
            'value': '钣金修复',
            'selected': false
          },
          {
            'key': '4',
            'value': '焊接痕迹',
            'selected': false
          }, {
            'key': '5',
            'value': '切割痕迹',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右C柱',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 41,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '3',
            'value': '钣金修复',
            'selected': false
          },
          {
            'key': '4',
            'value': '焊接痕迹',
            'selected': false
          }, {
            'key': '5',
            'value': '切割痕迹',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右B柱',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 42,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          },
          {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '锈蚀',
            'selected': false
          }, {
            'key': '10',
            'value': '钣金修复',
            'selected': false
          }, {
            'key': '11',
            'value': '更换过',
            'selected': false
          }, {
            'key': '12',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右前门',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 43,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '3',
            'value': '钣金修复',
            'selected': false
          },
          {
            'key': '4',
            'value': '焊接痕迹',
            'selected': false
          }, {
            'key': '5',
            'value': '切割痕迹',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右A柱',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 44,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          },
          {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '破损裂痕',
            'selected': false
          }, {
            'key': '10',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右后视镜',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 45,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微划痕',
            'selected': false
          }, {
            'key': '3',
            'value': '严重划痕(见底漆)',
            'selected': false
          },
          {
            'key': '4',
            'value': '轻微凹陷',
            'selected': false
          }, {
            'key': '5',
            'value': '严重凹陷',
            'selected': false
          }, {
            'key': '6',
            'value': '漆面色差',
            'selected': false
          }, {
            'key': '7',
            'value': '漆面爆裂',
            'selected': false
          }, {
            'key': '8',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '9',
            'value': '锈蚀',
            'selected': false
          }, {
            'key': '10',
            'value': '钣金修复',
            'selected': false
          }, {
            'key': '11',
            'value': '更换过',
            'selected': false
          }, {
            'key': '12',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右前叶子板',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 46,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '严重刮伤',
            'selected': false
          },
          {
            'key': '4',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '5',
            'value': '改装',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右前轮毂',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 47,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '严重刮伤',
            'selected': false
          },
          {
            'key': '4',
            'value': '胎纹过浅',
            'selected': false
          }, {
            'key': '5',
            'value': '改装',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右前轮胎',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 48,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微刮伤',
            'selected': false
          }, {
            'key': '3',
            'value': '严重刮伤',
            'selected': false
          },
          {
            'key': '4',
            'value': '变形',
            'selected': false
          }, {
            'key': '5',
            'value': '修复痕迹',
            'selected': false
          }, {
            'key': '6',
            'value': '喷漆修复',
            'selected': false
          }, {
            'key': '7',
            'value': '更换过',
            'selected': false
          }, {
            'key': '8',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '右裙边',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      }
    ],
    'machine_interior': [
      {
        'id': 49,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微渗油',
            'selected': false
          }, {
            'key': '3',
            'value': '漏油',
            'selected': false
          }, {
            'key': '4',
            'value': '轻微异响',
            'selected': false
          }, {
            'key': '5',
            'value': '严重异响',
            'selected': false
          }, {
            'key': '6',
            'value': '轻微抖动',
            'selected': false
          }, {
            'key': '7',
            'value': '严重抖动',
            'selected': false
          }, {
            'key': '8',
            'value': '烧机油',
            'selected': false
          }, {
            'key': '9',
            'value': '更换过',
            'selected': false
          }, {
            'key': '10',
            'value': '维修过',
            'selected': false
          }, {
            'key': '11',
            'value': '改装',
            'selected': false
          }, {
            'key': '12',
            'value': '气门室有胶质物',
            'selected': false
          }, {
            'key': '13',
            'value': '无法启动',
            'selected': false
          }, {
            'key': '14',
            'value': '节气门异响',
            'selected': false
          }, {
            'key': '15',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '发动机',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 50,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微渗油',
            'selected': false
          }, {
            'key': '3',
            'value': '漏油',
            'selected': false
          }, {
            'key': '4',
            'value': '轻微异响',
            'selected': false
          }, {
            'key': '5',
            'value': '严重异响',
            'selected': false
          }, {
            'key': '6',
            'value': '闯档',
            'selected': false
          }, {
            'key': '7',
            'value': '挂/换挡异常',
            'selected': false
          }, {
            'key': '8',
            'value': '离合器异常',
            'selected': false
          }, {
            'key': '9',
            'value': '档位松旷',
            'selected': false
          }, {
            'key': '10',
            'value': '更换过',
            'selected': false
          }, {
            'key': '11',
            'value': '维修过',
            'selected': false
          }, {
            'key': '12',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '变速箱',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 51,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微渗油',
            'selected': false
          }, {
            'key': '3',
            'value': '漏油',
            'selected': false
          }, {
            'key': '4',
            'value': '异响',
            'selected': false
          }, {
            'key': '5',
            'value': '更换过',
            'selected': false
          }, {
            'key': '6',
            'value': '维修过',
            'selected': false
          }, {
            'key': '7',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '转向机',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 52,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '轻微渗油',
            'selected': false
          }, {
            'key': '3',
            'value': '漏油',
            'selected': false
          }, {
            'key': '4',
            'value': '异响',
            'selected': false
          }, {
            'key': '5',
            'value': '改装',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '减震器',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 53,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '破损',
            'selected': false
          }, {
            'key': '3',
            'value': '异响',
            'selected': false
          }, {
            'key': '4',
            'value': '改装',
            'selected': false
          }, {
            'key': '5',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '消音器',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 54,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '污痕',
            'selected': false
          }, {
            'key': '3',
            'value': '磨损',
            'selected': false
          }, {
            'key': '4',
            'value': '破损',
            'selected': false
          }, {
            'key': '5',
            'value': '老化(龟裂或变褪色)',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '座椅',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 55,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '松旷',
            'selected': false
          }, {
            'key': '3',
            'value': '断裂',
            'selected': false
          }, {
            'key': '4',
            'value': '底部有水渍',
            'selected': false
          }, {
            'key': '5',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '安全带',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        images: [],
        'message': ''
      },
      {
        'id': 56,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '水渍',
            'selected': false
          }, {
            'key': '3',
            'value': '污痕',
            'selected': false
          }, {
            'key': '4',
            'value': '下垂',
            'selected': false
          }, {
            'key': '5',
            'value': '破损',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '顶蓬',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 57,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '污痕',
            'selected': false
          }, {
            'key': '3',
            'value': '磨损',
            'selected': false
          }, {
            'key': '4',
            'value': '破损',
            'selected': false
          }, {
            'key': '5',
            'value': '老化(龟裂或变褪色)',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '门饰板',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 58,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '污痕',
            'selected': false
          }, {
            'key': '3',
            'value': '破损',
            'selected': false
          }, {
            'key': '4',
            'value': '水渍或泥沙',
            'selected': false
          }, {
            'key': '5',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '地毯',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 59,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '磨损',
            'selected': false
          }, {
            'key': '3',
            'value': '破损',
            'selected': false
          }, {
            'key': '4',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '换挡杆',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 60,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '磨损',
            'selected': false
          }, {
            'key': '3',
            'value': '破损',
            'selected': false
          }, {
            'key': '4',
            'value': '拆卸痕迹',
            'selected': false
          }, {
            'key': '5',
            'value': '更换过',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '中央控制台',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 61,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '磨损',
            'selected': false
          }, {
            'key': '3',
            'value': '破损',
            'selected': false
          }, {
            'key': '4',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '方向盘',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 62,
        'damageList': [
          {
            'key': '1',
            'value': '无泥沙/无更换过/无清理痕迹',
            'selected': false
          },
          {
            'key': '2',
            'value': '有泥沙',
            'selected': false
          }, {
            'key': '3',
            'value': '有更换过',
            'selected': false
          }, {
            'key': '4',
            'value': '有清理痕迹',
            'selected': false
          }
        ],
        'note': '保险盒',
        'title': ['无泥沙/无更换过/无清理痕迹'],
        'defaultTitle': ['无泥沙/无更换过/无清理痕迹'],
        'images': [],
        'message': ''
      },
      {
        'id': 63,
        'damageList': [
          {
            'key': '1',
            'value': '无水渍或泥沙',
            'selected': false
          },
          {
            'key': '2',
            'value': '有水渍或泥沙',
            'selected': false
          }
        ],
        'note': 'EUC接口处',
        'title': ['无水渍或泥沙'],
        'defaultTitle': ['无水渍或泥沙'],
        'images': [],
        'message': ''
      },
      {
        'id': 64,
        'damageList': [
          {
            'key': '1',
            'value': '无锈迹',
            'selected': false
          },
          {
            'key': '2',
            'value': '有锈迹',
            'selected': false
          }
        ],
        'note': '点烟器底座',
        'title': ['无锈迹'],
        'defaultTitle': ['无锈迹'],
        'images': [],
        'message': ''
      },
      {
        'id': 65,
        'damageList': [
          {
            'key': '1',
            'value': '无水渍或泥沙',
            'selected': false
          },
          {
            'key': '2',
            'value': '有水渍或泥沙',
            'selected': false
          }
        ],
        'note': '烟灰缸底座',
        'title': ['无水渍或泥沙'],
        'defaultTitle': ['无水渍或泥沙'],
        'images': [],
        'message': ''
      },
      {
        'id': 66,
        'damageList': [
          {
            'key': '1',
            'value': '无霉味/无水渍或泥沙',
            'selected': false
          },
          {
            'key': '2',
            'value': '有霉味',
            'selected': false
          }, {
            'key': '3',
            'value': '有水渍或泥沙',
            'selected': false
          }
        ],
        'note': '驾驶舱和后备箱内',
        'title': ['无霉味/无水渍或泥沙'],
        'defaultTitle': ['无霉味/无水渍或泥沙'],
        'images': [],
        'message': ''
      },
      {
        'id': 67,
        'damageList': [
          {
            'key': '1',
            'value': '无水渍或泥沙',
            'selected': false
          },
          {
            'key': '2',
            'value': '有水渍或泥沙',
            'selected': false
          }
        ],
        'note': '后排座椅坐垫底部',
        'title': ['无水渍或泥沙'],
        'defaultTitle': ['无水渍或泥沙'],
        'images': [],
        'message': ''
      },
      {
        'id': 68,
        'damageList': [
          {
            'key': '1',
            'value': '无火烧或烟熏',
            'selected': false
          },
          {
            'key': '2',
            'value': '有火烧或烟熏',
            'selected': false
          }
        ],
        'note': '发动机线束及橡胶制品',
        'title': ['无火烧或烟熏'],
        'defaultTitle': ['无火烧或烟熏'],
        'images': [],
        'message': ''
      },
      {
        'id': 69,
        'damageList': [
          {
            'key': '1',
            'value': '无火烧或烟熏',
            'selected': false
          },
          {
            'key': '2',
            'value': '有火烧或烟熏',
            'selected': false
          }
        ],
        'note': '车辆覆盖件及驾驶舱',
        'title': ['无火烧或烟熏'],
        'defaultTitle': ['无火烧或烟熏'],
        'images': [],
        'message': ''
      }
    ],
    'appliance': [
      {
        'id': 70,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '纸盆喇叭有水印',
            'selected': false
          }, {
            'key': '3',
            'value': '不读碟',
            'selected': false
          }, {
            'key': '4',
            'value': '喇叭不响',
            'selected': false
          }, {
            'key': '5',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '音响',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 71,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '屏幕不亮',
            'selected': false
          }, {
            'key': '3',
            'value': '导航卡缺失',
            'selected': false
          }, {
            'key': '4',
            'value': '改装',
            'selected': false
          }, {
            'key': '5',
            'value': '无此配置',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '导航',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 72,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '不能折叠',
            'selected': false
          }, {
            'key': '3',
            'value': '不能调节',
            'selected': false
          }, {
            'key': '4',
            'value': '无此配置',
            'selected': false
          }, {
            'key': '5',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '电动后视镜',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 73,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '升降异响',
            'selected': false
          }, {
            'key': '3',
            'value': '不能升降',
            'selected': false
          }, {
            'key': '4',
            'value': '无此配置',
            'selected': false
          }, {
            'key': '5',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '电动车窗',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 74,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '渗水',
            'selected': false
          }, {
            'key': '3',
            'value': '无法打开',
            'selected': false
          }, {
            'key': '4',
            'value': '开关异响',
            'selected': false
          }, {
            'key': '5',
            'value': '无此配置',
            'selected': false
          }, {
            'key': '6',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '天窗',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 75,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '不制冷',
            'selected': false
          }, {
            'key': '3',
            'value': '无此配置',
            'selected': false
          }, {
            'key': '4',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '空调',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      },
      {
        'id': 76,
        'damageList': [
          {
            'key': '1',
            'value': '正常',
            'selected': false
          },
          {
            'key': '2',
            'value': '安全气囊灯亮',
            'selected': false
          }, {
            'key': '3',
            'value': 'ABS灯亮',
            'selected': false
          }, {
            'key': '4',
            'value': '手刹提示灯亮',
            'selected': false
          }, {
            'key': '5',
            'value': '胎压灯亮',
            'selected': false
          }, {
            'key': '6',
            'value': '发动机故障灯亮',
            'selected': false
          }, {
            'key': '7',
            'value': '机油灯亮',
            'selected': false
          }, {
            'key': '8',
            'value': '蓄电池提示灯亮',
            'selected': false
          }, {
            'key': '9',
            'value': '助力提示灯亮',
            'selected': false
          }, {
            'key': '10',
            'value': '保养提示灯亮',
            'selected': false
          }, {
            'key': '11',
            'value': '其他',
            'selected': false
          }
        ],
        'note': '仪表灯',
        'title': ['正常'],
        'defaultTitle': ['正常'],
        'images': [],
        'message': ''
      }
    ]
  }
}
